export const BACKEND_URL = 'https://vh7v6n2j12.execute-api.us-west-2.amazonaws.com/dev';
// export const BACKEND_URL = 'http://localhost:5000';
